import {
  Bell,
  CreditCard,
  FolderKanban,
  type LucideIcon,
  Plug,
  ScrollText,
  Settings,
  Users,
} from "lucide-react";

export interface WorkspaceNavItem {
  id: string;
  label: string;
  icon: LucideIcon;
}

export const workspaceNav: WorkspaceNavItem[] = [
  { id: "projects", label: "Projects", icon: FolderKanban },
  { id: "connections", label: "Connections", icon: Plug },
  { id: "members", label: "Members & access", icon: Users },
  { id: "channels", label: "Channels", icon: Bell },
  { id: "billing", label: "Billing", icon: CreditCard },
  { id: "audit", label: "Audit", icon: ScrollText },
  { id: "settings", label: "Settings", icon: Settings },
];
